"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayPeriodRedirect = exports.PAYPERIOD_REDIRECT_LINK = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Text_1 = require("@amzn/atoz-web/Text");
const Link_1 = require("@amzn/atoz-web/Link");
const consts_1 = require("../../../../../../consts");
exports.PAYPERIOD_REDIRECT_LINK = 'payperiod_redirect_link';
const PayPeriodRedirect = () => {
    return (react_1.default.createElement(Text_1.Text, null,
        react_1.default.createElement(react_i18next_1.Trans, { i18nKey: "time_and_attendance_PayPeriodRedirect_Text", components: {
                payLink: (react_1.default.createElement(Link_1.Link, { "data-test-id": exports.PAYPERIOD_REDIRECT_LINK, href: consts_1.ATOZ_FEATURE_PATH.TIME_CARD, textDecoration: "none" }))
            } })));
};
exports.PayPeriodRedirect = PayPeriodRedirect;
